/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Northern_EuropeInputs */

const bn_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উত্তর ইউরোপ`)
};

const de_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nordeuropa`)
};

const el_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βόρεια Ευρώπη`)
};

const en_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Northern Europe`)
};

const es_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norte de Europa`)
};

const fr_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe du Nord`)
};

const hi_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तरी यूरोप`)
};

const hu_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Észak-Európa`)
};

const id_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eropa Utara`)
};

const it_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nord Europa`)
};

const ja_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北欧`)
};

const ko_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`북유럽`)
};

const nl_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noord-Europa`)
};

const pl_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa Północna`)
};

const pt_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norte da Europa`)
};

const ru_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Северная Европа`)
};

const sv_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norra Europa`)
};

const tr_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuzey Avrupa`)
};

const uk_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Північна Європа`)
};

const vi_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắc Âu`)
};

const zh_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北欧`)
};

const zh_hant_geo_label_northern_europe = /** @type {(inputs: Geo_Label_Northern_EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北歐`)
};

/**
* | output |
* | --- |
* | "Northern Europe" |
*
* @param {Geo_Label_Northern_EuropeInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_northern_europe = /** @type {((inputs?: Geo_Label_Northern_EuropeInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Northern_EuropeInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_northern_europe(inputs)
	if (locale === "de") return de_geo_label_northern_europe(inputs)
	if (locale === "el") return el_geo_label_northern_europe(inputs)
	if (locale === "en") return en_geo_label_northern_europe(inputs)
	if (locale === "es") return es_geo_label_northern_europe(inputs)
	if (locale === "fr") return fr_geo_label_northern_europe(inputs)
	if (locale === "hi") return hi_geo_label_northern_europe(inputs)
	if (locale === "hu") return hu_geo_label_northern_europe(inputs)
	if (locale === "id") return id_geo_label_northern_europe(inputs)
	if (locale === "it") return it_geo_label_northern_europe(inputs)
	if (locale === "ja") return ja_geo_label_northern_europe(inputs)
	if (locale === "ko") return ko_geo_label_northern_europe(inputs)
	if (locale === "nl") return nl_geo_label_northern_europe(inputs)
	if (locale === "pl") return pl_geo_label_northern_europe(inputs)
	if (locale === "pt") return pt_geo_label_northern_europe(inputs)
	if (locale === "ru") return ru_geo_label_northern_europe(inputs)
	if (locale === "sv") return sv_geo_label_northern_europe(inputs)
	if (locale === "tr") return tr_geo_label_northern_europe(inputs)
	if (locale === "uk") return uk_geo_label_northern_europe(inputs)
	if (locale === "vi") return vi_geo_label_northern_europe(inputs)
	if (locale === "zh") return zh_geo_label_northern_europe(inputs)
	return zh_hant_geo_label_northern_europe(inputs)
});